export const INDIGO = "#441ce4";
export const CORAL = "#f36855";
